module.exports = __webpack_public_path__ + "img/Doc14a_20030023-062_6-Jan-1980.c3b03178.jpg";